import { OPEN } from '../../Access/utils/access-gate.util';
import { useDocumentEditorContext } from '../contexts/DocumentEditorContext/hooks/useDocumentEditorContext.hook';
import type { AccessGate } from '../../Access/types/access-gate.type';
import type { Editable } from '../types/editable.type';

// Whether the user may edit the content of the document: its sections, their order, its saves.
export const useContentEditGate = (): AccessGate =>
  useDocumentEditorContext<Editable>().props.routerSettings.gates
    ?.contentEdit ?? OPEN;
